/* START CART DRAWER */
  
  var cartDrawer = true;

   //TWITTER ADD TO CART
   // Twitter conversion tracking event code
    // Insert Twitter Event ID
    var lastClick = 0;
    var delay = 500;
    function twitterAddToCart(){
      if (lastClick >= (Date.now() - delay))
        return;
      lastClick = Date.now();
      var selectedSku = document.querySelector("#size-pick a.is-active");
      var currentPrice = selectedSku.getAttribute('data-vprice').replace("$","");
      twq('event', 'tw-oa74f-ode7f', {
        value: 1, // use this to pass the value of the conversion (e.g. 5.00)
        currency: 'USD', // use this to pass the currency of the conversion with an ISO 4217 code (e.g. ‘USD’)
        contents: [ // use this to pass an array of products or content
            // add all items to the array
            // use this for the first item
            {
              content_type: "",
              content_id: "",
              content_name: "",
              content_price: currentPrice,
              num_items: 1
            }], 
        email_address: "", // use this to pass a user’s email address
        phone_number: "" // phone number in E164 standard
      });
    }
    
  
  if(cartDrawer){

        window.getCartHtml = function(){
          fetch('/cart').then(function(response) {
            return response.text();
          }).then(function(data) {
            document.documentElement.classList.remove('v_gettingCart');
            window.updateAjaxCart(data);
          }).catch(function() {
            document.documentElement.classList.remove('v_gettingCart');
            console.log("error");
          });
        };
        window.updateAjaxCart = function(str){
          var cartDOM = document.createElement('div');
          cartDOM.innerHTML = str;
          //console.dir(cartDOM);
          var cartItems = cartDOM.querySelectorAll('.product-row');
          var ajaxCartItemsWrap = document.querySelector('#v_cartItems');
          var cartItemsTable = cartDOM.querySelector('#cartform table');
          var cartMsg = document.querySelector('#v_cartMsg');
          var subTotal = cartDOM.querySelector('#stotal');
          var savingsTotal = cartDOM.querySelector('#ctotalsavings');
          var ajaxSavedEl = document.querySelector('#v_savedMessage');
          var ajaxTotalEl = document.querySelector('#v_subTotal');
          var cartBannerCount = document.querySelector('#cartbannercount');
          var ajaxShip = document.querySelector('#v_freeShipMsg');
          var freeShip = cartDOM.querySelector('#freeship');
          if(cartItems.length){
            document.documentElement.classList.remove('v_cartHasNoItems');
            if(ajaxCartItemsWrap && cartItemsTable){
              ajaxCartItemsWrap.innerHTML = '<table class="table is-fullwidth is-striped">'+cartItemsTable.innerHTML+'</table>';
              manageInsertedItemsToCart();
            }
            if(cartMsg){
              var itmsString = cartItems.length > 1 ? "Items" : "Item";
              cartMsg.innerHTML = cartItems.length + ' ' + itmsString+' in your Cart';
            }
            if(subTotal && ajaxTotalEl){
              ajaxTotalEl.innerHTML = subTotal.innerHTML;
            }
            if(savingsTotal && ajaxSavedEl){
              ajaxSavedEl.innerHTML = savingsTotal.innerHTML;
              ajaxSavedEl.parentElement.classList.remove('is-hidden');
            }
            if(freeShip && ajaxShip){
              ajaxShip.innerHTML = '<p>'+freeShip.innerHTML+'</p>';
            }
          } else {
            document.documentElement.classList.add('v_cartHasNoItems');
            ajaxCartItemsWrap.innerHTML = '<div class="v_cartNoMsg has-text-centered"><h2>Your cart is currently empty.</h2><a href="/" class="button is-primary">Continue Browsing</a></div>';
            if(cartMsg){
              cartMsg.innerHTML = '0 Item in your Cart';
            }
            if(ajaxShip){
              ajaxShip.innerHTML = '';
            }
          }
        };
        window.manageInsertedItemsToCart = function(){
          var insertedItems = document.querySelectorAll('#v_cartItems .product-row');
          if(insertedItems.length){
            insertedItems.forEach(function(itm){
              var removeBtn = itm.querySelector('.control a[href*="/cart/change"]');
              var totalCol = itm.querySelector('td[data-label="Total"]');
              var qty = itm.querySelector('td[data-label="QTY"] > .field');
              var prodNameCol = itm.querySelector('td[data-label="Product"] + td');
              var varId = itm.getAttribute('data-sku');
              var plusBtn = itm.querySelector('.plus_prod');
              var minusBtn = itm.querySelector('.minus_prod');
              if(removeBtn && !itm.querySelector('.v_removeBtn')){
                totalCol.insertBefore(removeBtn, totalCol.children[0]);
                removeBtn.classList.add('v_removeBtn');
                removeBtn.setAttribute("aria-label", "Remove Product");
                removeBtn.setAttribute('onclick', 'return removeThisItemFromCart('+varId+',event)');
              }
              if(qty && prodNameCol && !itm.querySelector('.v_qtyWrap')){
                prodNameCol.appendChild(qty);
                qty.classList.add('v_qtyWrap');
              }
              if(plusBtn){
                plusBtn.onclick = function(){
                  var qtyInput = itm.querySelector('.qty_input');
                  if(qtyInput){
                    var qtyValue = qtyInput.value;
                    qtyValue++;
                    qtyInput.value = qtyValue;
                    document.documentElement.classList.add("v_processingCart");
                    updateItemsInCart(varId,qtyValue);
                  }
                };
              }
              if(minusBtn){
                minusBtn.onclick = function(){
                  var qtyInput = itm.querySelector('.qty_input');
                  if(qtyInput){
                    var qtyValue = qtyInput.value;
                    if(qtyValue > 1){
                      qtyValue--;
                      qtyInput.value = qtyValue;
                      document.documentElement.classList.add("v_processingCart");
                      updateItemsInCart(varId,qtyValue);
                    }
                  }
                };
              }
            });
          }
        };
        window.openCartDrawer = function(e){
          if(e){
            e.preventDefault();
            e.stopPropagation();
          }
          document.documentElement.classList.add("v_cartOpened");
          if(!document.documentElement.classList.contains('v_gettingCart')){
            document.documentElement.classList.add('v_gettingCart');
            getCartHtml();
          }
          document.querySelector('.v_cartDrawer').setAttribute("aria-hidden","false");
          document.querySelector('.v_cartDrawer').classList.remove("is-hidden");
          trapFocus();
          return;
        };
        window.closeCartDrawer = function(){
          document.documentElement.classList.remove("v_cartOpened");
          document.querySelector('.v_cartDrawer').setAttribute("aria-hidden","true");
          document.querySelector('.v_cartDrawer').classList.add("is-hidden");
        };
        window.removeThisItemFromCart = function(variant,e){
          e.preventDefault();
          e.stopPropagation();
          document.documentElement.classList.add("v_processingCart");
          updateItemsInCart(variant,0);
          return;
        };
        window.updateItemsInCart = function(variant, qty){
          document.documentElement.classList.add("v_processingCart");
          document.documentElement.classList.add('v_gettingCart');
          fetch('/cart/change.json', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              "id": variant.toString(),
              "quantity": qty
            })
          }).then(response => response.json()).then(data => {
            window.getCartHtml();
            document.documentElement.classList.remove('v_processingCart');
          }).catch((error) => {
            document.documentElement.classList.remove('v_processingCart');
            document.documentElement.classList.remove('v_gettingCart');
          });
        };
        (function eightees4605v1(){
          if(document.querySelectorAll('.top-cart[href="/cart"]').length && !document.querySelectorAll('.eightees4605v1').length){
            addCartDrawer();
            overridecartclick();
            getCartHtml();
            addCartCTAClick();
            var send = XMLHttpRequest.prototype.send;
            XMLHttpRequest.prototype.send = function() { 
              this.addEventListener('load', function() {
                overridecartclick();
                addCartCTAClick();
              });
              return send.apply(this, arguments);
            };
            document.body.classList.add('eightees4605v1');
          } else if(!document.querySelectorAll('.eightees4605v1').length) {
            requestAnimationFrame(eightees4605v1);
          }
          function addCartDrawer(){
            
          }
          function overridecartclick(){
            const cartLinks = document.querySelectorAll('a[href="/cart"]');
            if(cartLinks.length){
              cartLinks.forEach(function(cl){
                cl.setAttribute('onclick', 'return openCartDrawer(event);');
              });
            }
          }
          function addCartCTAClick(){
            var cartBtn = document.querySelector('#cart-button');
            var qtyIncrease = document.querySelector('#buy-wrap #add');
            var qtyDecrease = document.querySelector('#buy-wrap #subtract');
            //for add to cart on pdp
            if(cartBtn){
              cartBtn.addEventListener('click', function(){
                var hiddenInterval = setInterval(function(){
                  if(cartBtn.classList.contains('is-hidden')){
                    openCartDrawer();
                    clearInterval(hiddenInterval);
                    twitterAddToCart();
                  } else {
                    setTimeout(function(){
                      clearInterval(hiddenInterval);
                    },6000);
                  }
                },10);
              }); 
            }
            //for quantity + - on pdp
            if(qtyIncrease){
              qtyIncrease.addEventListener('click', function(){
                var waveFinder = setInterval(function(){
                  if(!qtyIncrease.querySelector('.wave')){
                    openCartDrawer();
                    clearInterval(waveFinder);
                  } else {
                    setTimeout(function(){
                      clearInterval(waveFinder);
                    },6000);
                  }
                },10);
              }); 
            }
            if(qtyDecrease){
              qtyDecrease.addEventListener('click', function(){
                var cartQtyEl = document.querySelector('#cartbannercount');
                var cartQty = cartQtyEl.innerText;
                if(+cartQty >= 2){
                  var waveFinderSub = setInterval(function(){
                    if(!qtyDecrease.querySelector('.wave')){
                      openCartDrawer();
                      clearInterval(waveFinderSub);
                    } else {
                      setTimeout(function(){
                        clearInterval(waveFinderSub);
                      },6000);
                    }
                  },10);
                }
              }); 
            }
          }
        })();



function trapFocus(){
  var  focusableElements =
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
  var vCartDrawer = document.querySelector('.v_cartContainer');
  var firstFocusableElement = vCartDrawer.querySelectorAll(focusableElements)[0]; // get first element to be focused inside modal
  var focusableContent = vCartDrawer.querySelectorAll(focusableElements);
  var lastFocusableElement = focusableContent[focusableContent.length - 1]; // get last element to be focused inside modal
  
  document.addEventListener('keydown', trappedFocus);
    
  function trappedFocus(e) {
    let isTabPressed = e.key === 'Tab' || e.keyCode === 9;
    if (event.keyCode === 13) {
      if(e.target.classList.contains('v_cartCloser')){
         window.closeCartDrawer();
      }
    }else if (event.keyCode === 27){
       window.closeCartDrawer();
    }
    
    if (!isTabPressed) {
      return;
    }
    if (e.shiftKey) { // if shift key pressed for shift + tab combination
      if (document.activeElement === firstFocusableElement) {
        lastFocusableElement.focus(); // add focus for the last focusable element
        e.preventDefault();
      }
    } else { // if tab key is pressed
      if (document.activeElement === lastFocusableElement) { // if focused has reached to last focusable element then focus first focusable element after pressing tab
        firstFocusableElement.focus(); // add focus for the first focusable element
        e.preventDefault();
      }
    }
  };
  firstFocusableElement.focus();
}


}
  /* END CART DRAWER */
  